module.exports = __webpack_public_path__ + "static/media/asb_ris_ass_and_saf_pla.647ba9a3.png";